export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-display text-foreground-950 mb-6">
            关于吃瓜爆料
          </h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              吃瓜爆料成立于2023年，是国内领先的娱乐资讯与真实内幕爆料平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的娱乐热点追踪与行业内幕深度分析。
            </p>
            <p>
              平台汇聚了来自娱乐产业各环节的匿名投稿者，涵盖影视制作、综艺录制、艺人经纪、品牌营销等多个领域。每一条爆料均经过专业编辑团队的多源交叉验证，确保内容的真实性和可信度。
            </p>
            <p>
              区别于传统娱乐媒体的标题党和碎片化搬运，吃瓜爆料坚持深度内容原创、多角度分析和信源可追溯三大原则。我们不制造谣言，只揭露真相——让每一个吃瓜群众都能看到娱乐圈最真实的一面。
            </p>
            <p>
              截至目前，平台已累计发布真实吃瓜爆料超过15,800条，日均更新50+条独家内容，月活跃用户突破280万。吃瓜爆料始终免费向所有用户开放，因为我们相信：真实的信息不应该被付费墙阻挡。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
            <div className="p-4 rounded-lg bg-background-50 border border-background-200/70">
              <div className="text-2xl font-display text-primary-500">15,800+</div>
              <div className="text-xs text-foreground-500 mt-1">累计真实爆料</div>
            </div>
            <div className="p-4 rounded-lg bg-background-50 border border-background-200/70">
              <div className="text-2xl font-display text-accent-500">98.6%</div>
              <div className="text-xs text-foreground-500 mt-1">内容真实率</div>
            </div>
            <div className="p-4 rounded-lg bg-background-50 border border-background-200/70">
              <div className="text-2xl font-display text-secondary-500">280万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}